export const LEFT_MENU_ACTIVE_ITEMS = {
  TIMELINE: 'timeline',
  FAMILY_TIMELINE: 'family-timeline'
}